module.exports = __webpack_public_path__ + "static/img/ccod6.2919fe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ccod6.png
// module id = U6II
// module chunks = 0